import request from "@/utils/request";
import download from "@/utils/download";

export const createOrUpdateHenganLoadingPlan = (data: any, id: string) =>
  request({
    url: `/hengan-loading-plans/${id}/product-assigned`,
    method: "POST",
    data,
  });

export const getHenganLoadingPlans = (params: any) =>
  request({
    url: "/hengan-loading-plans",
    method: "GET",
    params,
  });

export const getHenganLoadingPlansForWarehouse = (params: any) =>
  request({
    url: "/storage-hengan-loading-plans",
    method: "GET",
    params,
  });

export const addShippingOrder = (
  id: string,
  data: { shippingOrderId: string }
) =>
  request({
    url: `/hengan-loading-plans/${id}/shipping-order`,
    method: "PUT",
    data,
  });

export const addRemark = (id: string, data: { remark: string }) =>
  request({
    url: `/hengan-loading-plans/${id}/remark`,
    method: "PUT",
    data,
  });

export const getTransshipDeliveryInfo = (henganLoadingPlanId: string) =>
  request({
    url: `/hengan-loading-plans/${henganLoadingPlanId}/transship-info`,
    method: "GET",
  });

export const saveTransshipDeliveryInfo = (
  henganLoadingPlanId: string,
  data: any
) =>
  request({
    url: `/hengan-loading-plans/${henganLoadingPlanId}/transship-info`,
    method: "PUT",
    data,
  });

export const releaseContainerType = (
  henganLoadingPlanId: string,
  data: { containerTypes: any }
) =>
  request({
    url: `/hengan-loading-plans/${henganLoadingPlanId}/container-types`,
    method: "POST",
    data,
  });

export const deleteContainerType = (
  henganLoadingPlanId: string,
  containerTypeId: string
) =>
  request({
    url: `/hengan-loading-plans/${henganLoadingPlanId}/container-types/${containerTypeId}`,
    method: "delete",
  });

export const getHenganLoadingPlanDetail = (id: string) =>
  request({
    url: `/hengan-loading-plans/${id}/hengan-packing-lists`,
    method: "GET",
  });

/**
 * 查询仓库端出库计划的柜型配置信息
 * @param id 出库计划 ID
 */
export const getContainerTypeConfigurationInfoForWarehouse = (id: string) =>
  request({
    url: `/storage-hengan-loading-plans/${id}/loading-infos`,
    method: "GET",
  });

/**
 * 查询仓库端出库计划的驳货出库信息
 * @param id 出库计划 ID
 */
export const getTransshipInfoForWarehouse = (id: string) =>
  request({
    url: `/storage-hengan-loading-plans/${id}/transship-infos`,
    method: "GET",
  });

/**
 * 修改出库计划中主包装的包装信息
 * @param id 主包装 ID
 * @param data 包装信息
 */
export const updateHenganCustomsPackingInfo = (id: string, data: any) =>
  request({
    url: `/hengan-customs-packing/${id}`,
    method: "PUT",
    data,
  });

export const getHenganLoadingPlanPackingInfos = (id: string) =>
  request({
    url: `/hengan-loading-plans/${id}/hengan-packing-lists/hengan-customs-packing-set`,
    method: "GET",
  });

export const getHenganLoadingProblemPackingInfos = (id: string) =>
  request({
    url: `hengan-loading-plans/${id}/problem-customs-packing-set-and-unpacked-product`,
    method: "GET",
  });

export const confirmStockUp = (id: string,customsPackingIds: string[]) =>
  request({
    url: `/hengan-loading-plans/${id}/customs-packing/state`,
    method: "PUT",
    data: { customsPackingIds: customsPackingIds },
  });

export const confirmException = (customsPackingId: string) =>
  request({
    url: `/hengan-loading-plans/problems-customs-packing/state`,
    method: "PUT",
    data: { customsPackingIds: [customsPackingId] },
  });

export const getDetailForSeller = (id: string) =>
  request({
    url: `/hengan-loading-plans/${id}`,
    method: "GET",
  });

export const cancelHenganLoadingPlan = (id: string) =>
  request({
    url: `/hengan-loading-plans/${id}/state`,
    method: "PUT",
  });

export const packCustomsPacking = (id: string, data: any) =>
  request({
    url: `/hengan-loading-plans/${id}/customs-packing`,
    method: "POST",
    data,
  });

export const unpackCustomsPackingSet = (
    id: string,
    customsPackingIds: string[],
    inBulk: boolean,
    force = false) =>
  request({
    url: `/hengan-loading-plans/${id}/customs-packing-set`,
    method: "DELETE",
    data: { customsPackingIds, inBulk, force},
  });

export const getHenganLoadingPlanProductAssigned = (id: string) =>
  request({
    url: `/hengan-loading-plans/${id}/product-assigned`,
    method: "GET",
  });

export const createHenganLoadingPlanPackingInfo = (data: any, id: string) =>
  request({
    url: `/hengan-loading-plans/${id}`,
    method: "PUT",
    data,
  });

export const getOriginalPackingInfo = (id: string) =>
  request({
    url: `/hengan-loading-plans/newCustomsPackings/${id}`,
    method: "GET",
  });

export const confirmTransship = (id: string) =>
    request({
        url: `/hengan-loading-plans/${id}/confirm-transship`,
        method: "PUT"
    })

export const updateHenganLoadingPlanPackingInfos = (id: string, data: any) =>
    request({
        url: `/hengan-loading-plans/${id}/packing-infos`,
        method: "post",
        data,
    })

export const removeHenganLoadingPlanPackingInfos = (id: string, data: any) =>
    request({
        url: `/hengan-loading-plans/${id}/packing-infos`,
        method: "DELETE",
        data
    });

export const addLoadPlanPackingRemark = (id: string, data: any) =>
    request({
        url: `/hengan-loading-plans/${id}/loading-plan-packing-remark`,
        method: "PUT",
        data
    })

export const getHenganLoadingPlanStates = () =>
    request({
        url: "/hengan-loading-plan-states",
        method: "GET"
    });

// /hengan-loading-plans/{id}/download-detail
// 导出详情
export const exportHenganPlanDetail = (id: any) =>
  download({
    responseType: "blob",
    url: `/hengan-loading-plans/${id}/download-detail`,
    method: "get"
  });

// 校验选择的包装是否存在超发且剩余非库存是否满足超发
export const checkPacking = (data: any) =>
    request({
        url: `/customs-packing/exist-excess`,
        method: "POST",
        data:data
    });

// 取消备货
export const cancelPrepareGoods = (id: string) =>
    request({
        url: `/hengan-loading-plans/${id}/cancel-prepare_goods`,
        method: "PUT",
    });

export const downloadPreviewDetail = (ids: any[]) =>
    download({
        responseType: "blob",
        url: "/hengan-loading-plans/download-preview-detail",
        method: "POST",
        data:ids
    });
/**
 *  更新订舱单
 * @param id
 */
export const updateShippingOrder = (id: string, shippingOrderId: string) =>
    request({
        url: `/hengan-loading-plans/${id}/shipping-order/update`,
        method: "PUT",
        data: {
            shippingOrderId: shippingOrderId
        },
    });

// 报关计划-配置柜型/出库计划-已分配产品 中的装箱单产品列表
export const detailQueryQtyStepInfoByPackingList = (data) =>
    request({
        url: `/hengan-loading-plans/qty-step-info-by-packing-list`,
        method: "POST",
        data,
    });
// 报关计划-配置柜型/出库计划-已分配产品 中的PI产品列表
export const detailQueryQtyStepInfoByPi = (data) =>
    request({
        url: `/hengan-loading-plans/qty-step-info-by-pi`,
        method: "POST",
        data
    });
